// Drift: Analyse på Supabase (del af SupabaseApi – se supabase.ts). Databasen giver fakta og små aggregater
// (20261104000000_analyse.sql, kun med rettigheden analyse); dækningsbidraget regnes i src/core/analyse.ts som i testversionen.
import type { Api } from './api';
import { analyseRaaFraDb, historikFraDb, opsaetningFraDb, opsaetningTilDb, sammenlignFraDb, tjekOpsaetning } from '../../core/analyse';
import { ApiFejl } from './api';
import type { SbKontekst } from './sbKatalog';

export class SbAnalyse {
  constructor(private readonly c: SbKontekst) {}
  private async rpc<T>(navn: string, a: Record<string, unknown> = {}): Promise<T> {
    return (await this.c.k(this.c.sb.rpc(navn, { k: await this.c.kraevKlient(), ...a }))) as T;
  }
  analyse: Api['analyse'] = async (fra, til) => analyseRaaFraDb(await this.rpc('analyse_periode', { p_fra: fra, p_til: til }), fra, til);
  analyseSammenlign: Api['analyseSammenlign'] = async (fra, til) => sammenlignFraDb(await this.rpc('analyse_sammenlign', { p_fra: fra, p_til: til }), fra, til);
  analyseHistorik: Api['analyseHistorik'] = async () => historikFraDb(await this.rpc('analyse_historik'));
  analyseKunder: Api['analyseKunder'] = async (ids) => {
    if (!ids.length) return [];
    const r = await this.rpc<[string, number, number][]>('analyse_kunder', { p_kunder: ids.slice(0, 20) });
    return r.map(([kunde_id, ordrer, oms]) => ({ kunde_id, ordrer: Number(ordrer), omsInkl: Number(oms) }));
  };
  analyseOpsaetning: Api['analyseOpsaetning'] = async () => opsaetningFraDb(await this.rpc('analyse_opsaetning'));
  gemAnalyseOpsaetning: Api['gemAnalyseOpsaetning'] = async (o) => {
    const f = tjekOpsaetning(o);
    if (Object.keys(f).length) throw new ApiFejl(Object.values(f)[0], f);
    await this.rpc('gem_analyse_opsaetning', { p: opsaetningTilDb(o) });
  };
}
